import React from 'react';
import { TaskCommentTemplate } from 'themes/application/schedule/components';
import { observer } from 'mobx-react';
import { TaskCommentStore } from 'application/schedule/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new TaskCommentStore(rootStore, componentProps), 'taskCommentStore')
@observer
class TaskComment extends React.Component {
    render() {
        return <TaskCommentTemplate {...this.props} />
    }
}

export default TaskComment;